import React, { useEffect, useState, useContext } from 'react'
import { Link, useParams, withRouter } from 'react-router-dom'
import {
    Row,
    Col,
    Container,
    Card,
    CardBody,
    CardFooter,
    CardTitle,
    CardSubtitle,
    UncontrolledTooltip,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    FormGroup,
    Label,
    Input,
} from 'reactstrap'
import { isEmpty, concat } from 'lodash'
import toastr from "toastr"
import "toastr/build/toastr.min.css"
import { ReactMultiEmail, isEmail } from 'react-multi-email'
import 'react-multi-email/style.css'
import { isMobile } from 'react-device-detect'
import Breadcrumbs from '../../components/Common/Breadcrumb'
import ApiService from '../../data/services/ApiService'
import { GeneralContext } from '../../context/'
import ProductCard from '../../components/Common/ProductCard'
import { getImagesOfProduct } from '../../helpers/utils'

const { Remarkable } = require('remarkable')
const md = new Remarkable()

const LIMIT = 8

const View = (props) => {
    const generalContext = useContext(GeneralContext)
    const { setLoading } = generalContext

    const { slug } = useParams()
    const [catalog, setCatalog] = useState({})
    const [products, setProducts] = useState([])
    const [offset, setOffset] = useState(0)
    const [page, setPage] = useState(1)

    const [emailModal, setEmailModal] = useState(false)
    const toggleEmailModal = () => setEmailModal(!emailModal)

    const [emails, setEmails] = useState([])
    const [mensaje, setMensaje] = useState('')

    const shareText = `%20Este%20cat%C3%A1logo%20te%20va%20a%20encantar%20%F0%9F%A4%A9%20`
    const catalogPublicUrl = `https://mitiendasocial.com/catalogo/`

    async function fetchCatalogBySlug() {
        try {
            setLoading(true)
            const response = await ApiService.getCatalogBySlug(slug, '')
            setCatalog(response.data.catalog)
        } catch(e) {
            toastr.error(`${e.response.data.message}`, 'Error')
        } finally {
            setLoading(false)
        }
    }

    async function fetchProductsBySlug() {
        try {
            setLoading(true)
            const response = await ApiService.getProductsBySlug(slug, offset, LIMIT)
            const { products: productsResponse } = response.data
            const prods = productsResponse && productsResponse.filter(p => {
                return p.wholeSalePrice > 0
            })
            if (!isEmpty(products)) {
                const moreProducts = concat(products, prods)
                setProducts(moreProducts)
            } else {
                setProducts(prods)
            }
        } catch(e) {
            if (e.response) {
                toastr.error(`${e.response.data.message}`, 'Error')
            } else {
                toastr.error(`${e}`, 'Error')
            }
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        (async () => {
            await fetchCatalogBySlug()
        })()
    }, []) // eslint-disable-line

    useEffect(() => {
        (async function fetch() {
            await fetchProductsBySlug()
        })()
    }, [offset]) // eslint-disable-line

    const moreProducts = async () => {
        setPage(page + 1)
        setOffset(page * LIMIT)
    }

    const _shareOnWhatsApp = () => {
        window.open(`https://api.whatsapp.com/send?text=${shareText}${catalogPublicUrl}${catalog.slug}/productos`)
    }

    const goToProducts = () => {
        props.history.push(`/catalogos/detalles/${slug}/productos`)
    }

    const shareProduct = async (product) => {
        const productPublicUrl = `https://mitiendasocial.com/producto/`
        const shareText = `Este%20producto%20te%20va%20a%20encantar%20%F0%9F%A4%A9%F0%9F%A4%A9%20`
        window.open(`https://api.whatsapp.com/send?text=${shareText}${productPublicUrl}${product.supplierCode}`)
    }

    // await copyImg(product.gallery[0].fileName)

    // const copyImg = async (src) => {
    //     const PROXY_URL = "https://cors-anywhere.herokuapp.com/"
    //     const response = await fetch(`${PROXY_URL}${src}?crossorigin`)
    //     const blob = await response.blob()

    //     if (src.endsWith('.jpg') || src.endsWith('.jpeg')) {
    //         convertToPngAndCopyToClipboard(blob)
    //     } else if (src.endsWith('.png')) {
    //         copyToClipboard(blob)
    //     }
    //  }

    //  const convertToPngAndCopyToClipboard = (imgBlob) => {
    //     const imageUrl = window.URL.createObjectURL(imgBlob)
    //     const canvas = document.createElement('canvas')
    //     const ctx = canvas.getContext('2d')

    //     if (ctx) {
    //         const imageEl = document.createElement('img')
    //         imageEl.src = imageUrl
    //         imageEl.crossOrigin = 'anonymous'

    //         imageEl.onload = ({ target }) => {
    //             const { width, height } = target
            
    //             canvas.width = width
    //             canvas.height = height
    //             ctx.drawImage(target, 0, 0, width, height)
    //             canvas.toBlob(copyToClipboard, 'image/png', 1)
    //         }
    //     }
    // }
     
    // const copyToClipboard = (blob) => {
    //     if (!blob) { return }

    //     try {
    //         // eslint-disable-next-line 
    //         const clipboardItem = new ClipboardItem({ [blob.type]: blob })
    //         navigator.clipboard.write([clipboardItem])
    //     } catch (error) {
    //         console.log(error)
    //     }
    // }

    const itemAction = (product) => {
        props.history.push(`/catalogos/detalles/${slug}/productos/${product.id}`)
    }

    const _shareOnFacebook = (e) => {
        e.preventDefault()
        FB.ui({ // eslint-disable-line
            method: 'share',
            href: `${catalogPublicUrl}${catalog.slug}/productos`
        })
    }

    const _shareByEmail = async (e) => {
        e.preventDefault()
        try {
            toggleEmailModal()
            setLoading(true)
            const data = {
                emails,
                mensaje,
                slug: `${catalog.slug}`,
            }
            const response = await ApiService.shareCatalogByEmail(data, '')
            if (response.data.success) {
                setEmails([])
                setMensaje('')
                toastr.success("Catálogo compartido por email correctamente!", "¡Éxito!")
            }
        } catch (e) {
            if (e.response) {
                toastr.error(`${e.response.data.message}`, 'Error')
            } else {
                toastr.error(`${e}`, 'Error')
            }
        } finally {
            setLoading(false)
        }
    }

    const _copyURL = (e) => {
        e.preventDefault()
        const el = document.createElement('textarea')
        el.value = `${catalogPublicUrl}${catalog.slug}/productos`
        document.body.appendChild(el)
        el.select()
        document.execCommand('copy')
        document.body.removeChild(el)
        toastr.success("URL del catálogo copiada!", "¡Éxito!")
    }

    return (
        <React.Fragment>
            <div className="page-content">
                {!isEmpty(catalog) && (
                    <Container fluid>
                        <Breadcrumbs
                            title="Catálogos"
                            breadcrumbItem={catalog.name}
                            parentLink={`/catalogos`}
                        />

                        <Card>
                            <CardBody>
                                <CardTitle>Temporada: {catalog.season}</CardTitle>
                                <CardSubtitle>Catálogo: {catalog.supplier.nombreComercial}</CardSubtitle>
                                <Link id={'view'} to={`/catalogo/${catalog.slug}`}>
                                    <div className="product-img position-relative">
                                        <img src={`https://storage.googleapis.com/vendora-storage/catalogs/${catalog.image}`} alt="" className="img-fluid mx-auto d-block" />
                                    </div>
                                </Link>
                            </CardBody>

                            <CardFooter className="bg-transparent border-top">
                                <div className="contact-links d-flex font-size-20">
                                    <div className="flex-fill">
                                        {catalog.catalogFile && (
                                            <a id={'download'} href={`https://storage.googleapis.com/vendora-storage/catalogs/${catalog.catalogFile}`}>
                                                <i className="mdi mdi-download"></i> { !isMobile ? 'Descargar' : ''}

                                                <UncontrolledTooltip placement="top" target={'download'}>
                                                    Descargar Catálogo
                                                </UncontrolledTooltip>
                                            </a>
                                        )}
                                    </div>

                                    <div className="flex-fill">
                                        {(catalog.catalogFile || catalog.viewWithIssuu) && (
                                            <Link id={'view'} to={`/catalogo/${catalog.slug}`}>
                                                <i className="mdi mdi-eye"></i> { !isMobile ? 'Ver Catálogo' : ''}

                                                <UncontrolledTooltip placement="top" target={'view'}>
                                                    Ver Catálogo
                                                </UncontrolledTooltip>
                                            </Link>
                                        )}
                                    </div>

                                    <div className="flex-fill">
                                        <UncontrolledDropdown>
                                            <DropdownToggle className="card-drop" tag="i" style={{ cursor: 'pointer', fontStyle: 'normal' }}>
                                                <i className="mdi mdi-share font-size-18"></i> { !isMobile ? 'Compartir' : ''}
                                            </DropdownToggle>
                                            <DropdownMenu right>
                                                <DropdownItem
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={ _shareOnFacebook }
                                                >
                                                    <i className="mdi mdi-facebook font-size-16 mr-2"></i> Compartir en Facebook
                                                </DropdownItem>
                                                <DropdownItem
                                                    onClick={toggleEmailModal}
                                                >
                                                    <i className="mdi mdi-email font-size-16 mr-2"></i> Compartir por email
                                                </DropdownItem>
                                                <DropdownItem
                                                    href="#"
                                                    onClick={_copyURL}
                                                >
                                                    <i className="mdi mdi-link font-size-16 mr-2"></i> Copiar URL
                                                </DropdownItem>
                                            </DropdownMenu>
                                        </UncontrolledDropdown>
                                    </div>

                                    <div className="flex-fill">
                                        <button onClick={ _shareOnWhatsApp } 
                                            target={`_blank`}
                                            className={`btn btn-whatsapp`}>
                                            <i className="bx bxl-whatsapp"></i> Compartir
                                        </button>
                                    </div>
                                </div>
                            </CardFooter>
                        </Card>
                        <Card>
                            <CardBody>
                                <CardTitle>Conoce tu catálogo</CardTitle>

                                <div dangerouslySetInnerHTML={{ __html: md.render(catalog.description) }} />
                            </CardBody>
                        </Card>
                        <Card>
                            <CardBody>
                                <div className="contact-links d-flex font-size-20">
                                    <CardTitle className="flex-fill">Top productos</CardTitle>
                                    {!isEmpty(products) && (<div>
                                        <button
                                            onClick={ goToProducts } 
                                            className={`btn btn-secondary`}>
                                            Ver todos los productos
                                        </button>
                                    </div>)}
                                </div>
                            </CardBody>
                            <Row>
                                {!isEmpty(products) && products.map(
                                    (item, key) => (
                                        <Col key={key} sm={3} style={{ textAlign: 'center', marginBottom: '15px' }}>
                                            <ProductCard
                                                photos={getImagesOfProduct(item.gallery)}
                                                code={`${item.supplierCode ? `Código ${item.supplierCode}` : ''}`}
                                                price={`${item.wholeSalePrice || 0}`}
                                                productName={item.name}
                                                showVariants={false}
                                                showFooterOptions
                                                shareButtonText=''
                                                shareButtonAction={() => shareProduct(item)}
                                                itemAction={() => itemAction(item)}
                                            />
                                        </Col>
                                    )
                                )}
                            </Row>
                            {!isEmpty(products) && (
                                <div className="text-center" style={{ padding: '32px 0' }}>
                                    <button
                                        onClick={ moreProducts } 
                                        className={`btn btn-secondary`}
                                    >
                                        Ver más productos
                                    </button>
                                </div>
                            )}
                        </Card>
                    </Container>
                )}
            </div>
            <div>
                <Modal isOpen={emailModal} toggle={toggleEmailModal}>
                    <ModalHeader toggle={toggleEmailModal}>Compartir por email</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col sm={12}>
                                <FormGroup>
                                    <Label className="control-label">
                                        Para *
                                    </Label>
                                    <ReactMultiEmail
                                        emails={emails}
                                        onChange={(emails) => {
                                            setEmails(emails)
                                        }}
                                        validateEmail={email => {
                                            return isEmail(email);
                                        }}
                                        getLabel={(email, index, removeEmail) => {
                                            return (
                                                <div data-tag key={index}>
                                                    {email}
                                                    <span data-tag-handle onClick={() => removeEmail(index)}>
                                                        ×
                                                    </span>
                                                </div>
                                            )
                                        }}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12}>
                                <FormGroup>
                                    <Label className="control-label">
                                        Mensaje
                                    </Label>
                                    <Input
                                        type="textarea"
                                        name="mensaje"
                                        id="mensaje"
                                        required
                                        value={mensaje}
                                        onChange={(event) => {
                                            setMensaje(event.target.value)
                                        }}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button className="btn btn-default btn-rounded waves-effect waves-light mb-2 mr-2" onClick={toggleEmailModal}>Cancelar</Button>{' '}
                        <Button color="primary" className="btn btn-success btn-rounded waves-effect waves-light mb-2 mr-2" onClick={_shareByEmail}>Compartir</Button>
                    </ModalFooter>
                </Modal>
            </div>
        </React.Fragment>
    )
}

export default withRouter(View)
